'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/constants/AvatarSize.js
// module id = 94
// module chunks = 0 1